import React, { Component } from "react";
import { Table, Modal, Image } from "react-bootstrap";

import { appConfig } from "../../../config";
var dateFormat = require("dateformat");
class ChemistPaymentView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const data =
      this.props.ChemistPaymentDtls && this.props.ChemistPaymentDtls.item
        ? this.props.ChemistPaymentDtls && this.props.ChemistPaymentDtls.item
        : null;

    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>
                  Chemist Payment Details
                </span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="feedbkModalTbl">
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td className="feedbkTdWdth">Reference Number</td>
                        <td className="storeModalCap">
                          {data !== null && data.invNo}
                        </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Order ID</td>
                        <td className="storeModalCap">
                          {data !== null && data.orderNo}
                        </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Distributor Organization</td>
                        <td className="storeModalCap">
                          {data !== null && data.recptDtls&& data.recptDtls.name}
                        </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Distributor Name</td>
                        <td className="storeModalCap">
                          {data !== null && data.recptId&&data.recptId.fullName}
                        </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Chemist Organization</td>
                        <td className="storeModalCap">
                          {data !== null && data.userCmstDtls&&data.userCmstDtls.name}
                        </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Chemist Name</td>
                        <td className="storeModalCap">
                          {data !== null && data.userId&&data.userId.fullName}
                        </td>
                      </tr>

                      {/* <tr>
                        <td>Order No.</td>
                        <td className="storeModalCap">
                          {data !== null && data.orderId.orderNo}
                        </td>
                      </tr>
                      <tr>
                        <td>Voucher No.</td>
                        <td className="storeModalCap">
                          {data !== null && data.vouchrNo}
                        </td>
                      </tr>
                      <tr>
                        <td>Voucher Date</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.vouchrDate != null &&
                            dateFormat(data.vouchrDate, "mediumDate")}
                        </td>
                      </tr>
                      <tr>
                        <td>Paid Date</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.paidDate != null &&
                            dateFormat(data.paidDate, "mediumDate")}
                        </td>
                      </tr> */}
                      <tr>
                        <td>Amount</td>
                        <td className="storeModalCap">
                          {data !== null && data.paidAmnt}
                        </td>
                      </tr>
                      <tr>
                        <td>Payment Mode</td>
                        <td className="storeModalCap">
                          {data !== null && data.orderId && data.orderId.payMode}
                        </td>
                      </tr>
                      {/*  <tr>
                        <td>Org Id</td>
                        <td className="storeModalCap">
                              {data !== null && data.orgId.n}
                            </td>
                      </tr> */}
                      <tr>
                        <td>Payment Status</td>
                        <td className="storeModalCap">
                          {data !== null && data.status}
                        </td>
                      </tr>
                      <tr>
                        <td> Created Date</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            data.createdAt !== null &&
                            dateFormat(data.createdAt, "mediumDate")}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ChemistPaymentView;
